import React from 'react';
import { Link } from 'react-router-dom';
import heroLoipen from '@/assets/hero-loipen.jpg';
import { useLanguage } from '@/hooks/useLanguage';

const EditorialInterlude = () => {
  const { language } = useLanguage();
  return (
    <section
      className="relative isolate overflow-hidden bg-ink text-paper"
      aria-label={language === 'en' ? 'Editorial break' : 'Editorial Pause'}
    >
      <div className="relative h-[60vh] min-h-[420px] md:h-[70vh] lg:h-[78vh] w-full">
        <img
          src={heroLoipen}
          alt=""
          aria-hidden
          className="absolute inset-0 w-full h-full object-cover opacity-80"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/40 via-ink/25 to-ink/70" />

        <div className="relative z-10 h-full flex items-end">
          <div className="container mx-auto px-5 sm:px-8 pb-14 md:pb-20">
            <div className="max-w-3xl">
              <p className="text-[11px] tracking-[0.32em] uppercase text-ice/90 mb-5">
                {language === 'en' ? '— A quiet moment' : '— Ein stiller Moment'}
              </p>
              <h3 className="font-display text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-paper">
                {language === 'en' ? (
                  <>
                    Where the trail begins,
                    <span className="block italic font-light text-paper/80">the noise fades.</span>
                  </>
                ) : (
                  <>
                    Wo die Loipe beginnt,
                    <span className="block italic font-light text-paper/80">verstummt der Lärm.</span>
                  </>
                )}
              </h3>
              <div className="mt-8">
                <Link
                  to="/stories"
                  className="inline-flex items-center gap-3 text-sm tracking-wide text-paper/90 hover:text-paper border-b border-paper/30 hover:border-paper pb-1 transition-colors"
                >
                  {language === 'en' ? 'Read our stories' : 'Unsere Geschichten lesen'}
                  <span aria-hidden>→</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EditorialInterlude;
